(function (upp) {
    'use strict';

    upp.directive('modalUserActivatedSuccessTpl', ['$timeout',
        function ($timeout) {
            var modal;

            return {
                restrict: 'E',
                replace: true,
                templateUrl: require('../templates/modal-user-activated-success-tpl.html'),
                link: function (scope, element) {
                    // open the modal
                    scope.$on('registerSuccess:open', function () {
                        modal = modal || element;

                        modal.modal('show');

                        // send event
                        modal.one('hidden', function () {
                            $timeout(function () {
                                scope.$broadcast('emailRestore:close');
                            }, 500);

                        });

                        // close the modal
                        scope.$on('registerSuccess:close', function () {
                            modal.modal('hide');
                        });
                    });
                }
            }
        }]);

}(upp));


// WEBPACK FOOTER //
// ./src/app/plugins/login/directives/modal-user-activated-success-tpl_directive.js